<template>
  <div class="home">
    <img class="logo" alt="logo" src="../assets/logo.png" />
    <div class="container row">
      <div class="comments col-xs-12 col-sm-12 col-md-12 col-lg-6">
        <h5>New comments</h5>
        <hr />
        <div class="" v-if="!comments.size">
          Inga nya kommentarer!
        </div>
        <div
          v-for="(song, idx) in Array.from(comments)"
          class="song"
          :key="idx"
        >
          <router-link :to="{ path: `/song/${song[0]}` }"
            ><span class="title">{{ titles[song[0]] }}</span></router-link
          >
          <div v-for="(comment, idy) in song[1]" class="comment" :key="idy">
            <label>
              <span class="commenter"
                ><img v-bind:src="comment.createdBy.picture" alt="" />{{
                  comment.createdBy.name
                }}
              </span>
              <span class="date"
                >{{ new Date(comment.created).toLocaleDateString() }}
                {{ new Date(comment.created).toLocaleTimeString() }}
              </span>
            </label>
            {{ comment.comment }}
          </div>
          <hr />
        </div>
      </div>
      <div class="uploads col-xs-12 col-sm-12 col-md-12 col-lg-6">
        <h5>Missing your rating</h5>
        <hr />
        <div class="song" v-for="(song, idx) in unrated" :key="idx">
          <router-link :to="{ path: song.url }"
            ><span class="title">{{ song.name }}</span></router-link
          >
          <b-badge
            class="avarage"
            pill
            :variant="getVariant(song.avarageRating)"
            >{{ song.avarageRating }}</b-badge
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.home {
  .logo {
    width: 85%;
    max-width: 600px;
  }
  a {
    font-weight: bold;
    color: #2c3e50;
    &:hover {
      color: #2c3e50;
    }
  }
  h5 {
    margin: 10px 0 20px;
  }
  hr {
    width: 85%;
  }
  label {
    width: 100%;
    text-align: left;
  }

  ul {
    padding: 0;
  }

  .date {
    font-size: 12px;
  }
  .name {
    font-size: 12px;
  }

  .container {
    margin: 0 auto;

    hr {
      width: 100%;
    }

    .comments {
      margin-bottom: 50px;

      .song {
        .title {
          font-weight: bold;
        }

        .commenter {
          font-weight: bold;
          padding-top: 2px;

          img {
            width: 24px;
            height: auto;
            margin: -2px 5px 0 0;
            border-radius: 12px;
          }
        }

        .comment {
          margin-top: 20px;
          text-align: left;
          white-space: pre-line;
        }

        .comment-input {
          width: 100%;
          height: 120px;
          margin-bottom: 10px;
        }
      }
    }
  }

  .song {
    margin: 15px 0;
    text-align: left;

    a {
      color: #2c3e50;
    }
    .avarage {
      margin-left: 5px;
      pointer-events: none;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>

<script>
import { loggedInUser, db } from "../firebaseConfig";
import { getVariant } from "../utils";

export default {
  name: "home",
  data() {
    return {
      comments: new Map(),
      titles: {},
      unrated: [],
    };
  },
  async created() {
    const currentUser = await loggedInUser;
    db.collection("songs")
      .where("active", "==", true)
      .onSnapshot((songs) => {
        songs.forEach((song) => {
          if (
            !song.data().rating ||
            (song.data().rating && !song.data().rating[currentUser.displayName])
          ) {
            // Calculate avarage rating
            const allRating = song.data().rating ? song.data().rating : {};
            let avarageRating;
            // Calculate avarage rating
            let people = 0;
            let totalRating = 0;
            for (const key in allRating) {
              if (allRating.hasOwnProperty(key)) {
                people++;
                totalRating += allRating[key];
              }
            }
            avarageRating = isNaN(totalRating / people)
              ? undefined
              : (totalRating / people).toFixed(1);

            this.unrated[this.unrated.length] = {
              name: song.data().name,
              url: `/song/${song.id}`,
              avarageRating: avarageRating,
            };
          }
        });
      });

    const lastSignIn = new Date(currentUser.lastSignInTime).getTime();
    db.collection("comments")
      .where("created", ">", lastSignIn)
      .onSnapshot((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let obj = doc.data();
          // Check if user has written (or read) comment
          if (
            obj.createdBy.uid !== currentUser.uid &&
            obj.readBy &&
            !obj.readBy[currentUser.uid]
          ) {
            if (!this.comments.has(obj.song))
              this.comments.set(obj.song, [obj]);
            else this.comments.get(obj.song).push(obj);
          }
        });

        let promises = [];

        this.comments.forEach((song, key) => {
          promises[promises.length] = db
            .collection("songs")
            .doc(key)
            .get()
            .then((songSnapshot) => {
              this.titles[key] = songSnapshot.data().name;
            });
        });

        Promise.all(promises).then(() => {
          this.$forceUpdate();
        });
      });
  },
  methods: {
    getVariant: getVariant,
  },
};
</script>
